import { LockModel, RootState, StoreConstants } from '@/types';
import { ActionTree } from 'vuex';
import { ListMaintenanceState } from '@/types/store/configuration/listMaintenance';
import { LockService } from '@/services/LockService';
import store from '@/store';

const ListMaintenance = StoreConstants.ListMaintenance;

export const actions: ActionTree<ListMaintenanceState, RootState> = {
  [ListMaintenance.Actions.ExtendLock]({ commit, getters }) {
    const currentLock = getters.entityLock as LockModel | undefined;
    if (currentLock && currentLock.isLockedByCurrentSessionId) {
      commit(ListMaintenance.Mutations.SetExtendingListLock, true);
      LockService.extendLockAsync(currentLock.id)
        .then((response: LockModel) => {
          const payload: LockModel = response;
          commit(ListMaintenance.Mutations.ExtendListLock, payload);
          commit(ListMaintenance.Mutations.SetExtendingListLock, false);
        })
        .catch((error: any) => {
          commit(ListMaintenance.Mutations.ExpireListLock, error);
          commit(ListMaintenance.Mutations.SetExtendingListLock, false);
        });
    }
  },
  async [ListMaintenance.Actions.ReleaseBuiltInListLock]({ commit, getters }, keepReleaseLockCallAlive = false) {
    const currentLock = getters.entityLock as LockModel | undefined;
    if (currentLock && currentLock.isLockedByCurrentSessionId) {
      await LockService.releaseLockAsync(currentLock.id, keepReleaseLockCallAlive);
      commit(ListMaintenance.Mutations.ExpireListLock);
    }
  },
  [ListMaintenance.Actions.SetExtendingLock]({ commit }, payload: boolean) {
    commit(ListMaintenance.Mutations.SetExtendingListLock, payload);
  },
  [ListMaintenance.Actions.SetComponentName]({ commit }, payload: string) {
    commit(ListMaintenance.Mutations.SetComponentName, payload);
  },
  [ListMaintenance.Actions.SetErrorModel]({ commit }, payload: string) {
    commit(ListMaintenance.Mutations.SetErrorModel, payload);
  },
  [ListMaintenance.Actions.SetIsDirty](_, payload: boolean) {
    store.dispatch('applicationDirtyStore/setApplicationDirty', payload);
  },
  [ListMaintenance.Actions.SetEntityLock]({ commit }, payload: LockModel) {
    commit(ListMaintenance.Mutations.SetEntityLock, payload);
  }
};
